import {defineMessages} from 'react-intl';

export const defaultResponseMessages = defineMessages({
  okText: {
    id: 'ComposeMessageDrawer.okText', //ID should not be changed due to manual translations review for HORIZONWEB-12490
    defaultMessage: 'OK',
  },
  needHelpText: {
    id: 'ComposeMessageDrawer.needHelpText', //ID should not be changed due to manual translations review for HORIZONWEB-12490
    defaultMessage: 'Need Help',
  },
  acknowledgeText: {
    id: 'ComposeMessageDrawer.acknowledgeText',
    defaultMessage: 'Acknowledge',
  },
});
